<template>
  <div>
    <div class="login_wrap">
      <div class="login_img">
        <img src="../../assets/logo-red.png" height="36" />
      </div>
      <h3>电子合同下载</h3>
      <div class="contract-wrap">
        <div class="contract-container">
          <div class="do-form contract-item" v-for="(item,index) in list" :key="index">
            <Checkbox :value="item" v-model="item.check" class="contract-label"></Checkbox>
            <div class="contract-name" @click="preview(item)">{{item.contractRename}}</div>
            <button class="download-btn" @click="handleDownload(item)">下载</button>
          </div>
          <div class="footer">
            <button class="do-btn do-btn-red footer-btn checkall" @click="handleCheckAll()">全选</button>
            <button class="do-btn do-btn-red footer-btn batch-download" @click="pageDownload()">批量下载</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import config from '../../http/config'
export default {
  name: 'contract-download',
  data() {
    return {
      choose: false,
      indeterminate: false,
      checkAll: false,
      list: [],
      type: localStorage.getItem('contractType')
    }
  },
  methods: {
    queryList() {
      this.list = JSON.parse(sessionStorage.getItem('contractList'))
      if (this.type != 'localContract') {
        this.list.forEach((item, i) => {
          item.contractRename = item.contractName
        })
      }
    },
    /* 全选 */
    handleCheckAll() {
      let list = this.list
      let flag = true
      for (let i = 0; i < list.length; i++) {
        if (!list[i].check) {
          flag = false
        }
      }
      if (!flag) {
        for (let i = 0; i < list.length; i++) {
          this.list[i].check = true
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          this.list[i].check = false
        }
      }
      this.$forceUpdate()
    },
    /* 单个下载 */
    handleDownload(item) {
      let id = item.id
      if (!id) {
        this.$Message.error('请选择要下载的合同！')
        return
      }
      let url = ''
      if (this.type == 'extendContract' || this.type == 'transferContract') {
        url =  process.env.BASE_API + '/extendContract/api/download?docNos=' + item.docNo
        if (this.type == 'transferContract') {
          url =  process.env.BASE_API + '/transferContract/api/download?docNos=' + item.docNo
        }
        axios
          .get(url, { responseType: 'blob' })
          .then(res => {
            this.convertRes2Blob(
              new Blob([res.data], { type: 'application/zip' }),
              item.contractRename + '.zip'
            )
          })
        return
      } else if (this.type == 'localContract') {
        url =
          process.env.BASE_API +
          '/localContract/api/download?id=' +
          id +
          '&_t=' +
          Date.parse(new Date()) / 1000
      } else {
        url =
          process.env.BASE_API +
          '/contract/api/download?id=' +
          id +
          '&_t=' +
          Date.parse(new Date()) / 1000
      }
      var ua = navigator.userAgent.toLowerCase()
      if (ua.includes('android') && ua.includes('miui')) {
        let a = document.createElement('a')
        a.download = item.contractRename + '.pdf'
        a.href = url
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        window.location.href = url
      }
    },
    /* 预览合同 */
    preview(item) {
      // 预览
      let previewUrl = ''
      if (this.type == 'extendContract') {
        previewUrl =
          process.env.BASE_API +
          '/extendContract/api/view-contract-file?docNo=' +
          item.docNo
      } else if (this.type == 'transferContract') {
        previewUrl =
          process.env.BASE_API +
          '/transferContract/api/view-contract-file?docNo=' +
          item.docNo
      } else if (this.type == 'localContract') {
        previewUrl =
          process.env.BASE_API +
          '/print/api/view-localContract-file?id=' +
          item.id +
          '&_t=' +
          Date.parse(new Date()) / 1000
      } else {
        previewUrl =
          process.env.BASE_API +
          '/print/api/view-contract-file?id=' +
          item.id +
          '&_t=' +
          Date.parse(new Date()) / 1000
      }
      sessionStorage.setItem('pdfUrl', encodeURIComponent(previewUrl))
      const ss = this.$router.resolve({ path: '/contract-pdf-view' })
      console.log(ss.href)
      window.open(ss.href, '_blank')
    },
    /* 续签批量下载 转签批量下载*/
    pageDownloadExtend() {
      let ts = this
      let checkedDocNos = []
      this.list.forEach(function(item) {
        if (item.check) {
          checkedDocNos.push(item.docNo)
        }
      })
      if (checkedDocNos.length < 1) {
        this.$Message.error('请选择要下载的合同！')
        return
      }
      let extendContractParams = {
        docNos:checkedDocNos
      }
      let downloadUrl = config.baseURL + '/extendContract/api/download'
      if (this.type == 'transferContract') {
        downloadUrl = config.baseURL + '/transferContract/api/download'
      }
      axios
        .get(downloadUrl, {
          responseType: 'blob',
          params: extendContractParams,
          paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
          }
        })
        .then(res => {
          ts.convertRes2Blob(
            new Blob([res.data], { type: 'application/zip' })
          )
        })
    },
    /* 批量下载 */
    pageDownload() {
      if(this.type == 'extendContract' || this.type == 'transferContract'){
        this.pageDownloadExtend()
        return
      }
      let checkedIds = []
      let ts = this
      this.list.forEach(function(item) {
        if (item.check) {
          checkedIds.push(item.id)
        }
      })
      if (checkedIds.length < 1) {
        this.$Message.error('请选择要下载的合同！')
        return
      }
      let params = {
        ids: checkedIds,
        _t: Date.parse(new Date()) / 1000
      }
      if (this.type == 'localContract') {
        axios
          .get(config.baseURL + '/localContract/api/batchDownload', {
            responseType: 'blob',
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params, { indices: false })
            }
          })
          .then(res => {
            ts.convertRes2Blob(
              new Blob([res.data], { type: 'application/zip' })
            )
          })
      } else {
        axios
          .get(config.baseURL + '/contract/api/batchDownload', {
            responseType: 'blob',
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params, { indices: false })
            }
          })
          .then(res => {
            ts.convertRes2Blob(
              new Blob([res.data], { type: 'application/zip' })
            )
          })
      }
    },
    convertRes2Blob(blob,fileName) {
      let url = window.URL.createObjectURL(blob)
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName||'合同.zip')
      document.body.appendChild(link)
      link.click()
    }
  },
  mounted() {
    this.queryList()
  }
}
</script>

<style scoped>
.login_img {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
img {
  margin-top: 30px;
}
.login_wrap h3 {
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  margin-top: 30px;
  font-weight: bolder;
}
.contract-wrap {
  display: flex;
  justify-content: center;
  padding-top: 28px;
}
.contract-container {
  width: 615px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  text-align: center;
}
.contract-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid #eeeeeea6;
}
.contract-label {
  width: 15px;
  padding-left: 16px;
}
.contract-name {
  width: 72%;
  text-align: left;
  padding-left: 10px;
  font-size: 14px;
  line-height: 28px;
}
.download-btn {
  padding: 0;
  width: 18%;
  font-size: 14px;
  color: #d61f20;
  background-color: #ffffff;
  border-color: transparent;
}
.footer {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  margin-top: 30px;
}
.footer-btn {
  height: 48px;
  border: 0;
  border-radius: 24px;
  color: #fff;
  background: #efefef;
  font-size: 17px;
  -webkit-box-shadow: 0 18px 18px 0 rgba(10, 31, 68, 0.12);
  box-shadow: 0 18px 18px 0 rgba(10, 31, 68, 0.12);
  background-image: linear-gradient(240deg, #ed4243, #d61f20);
}
.checkall {
  width: 40%;
  margin-right: 10px;
}
.batch-download {
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/contract/contract-download.vue